import AssessmentsSerializer from './base';

export default class GradeSchedule extends AssessmentsSerializer {}
